import { fetchUserAttributes } from 'aws-amplify/auth'
let userDetails

const clearUserDetails = async () => {
  userDetails = undefined
}

const setUserDetails = async () => {
  try {
    const attributes = await fetchUserAttributes()
    if (attributes?.name && attributes?.email) {
      const { name, email } = attributes
      userDetails = { name, email }
    }
  } catch (err) {
    // TODO: This functions is already setup like using global variables and used everywhere when project was initiated need to find better way to handle this
  }
}

const getUserDetails = async () => {
  if (userDetails) {
    return userDetails
  } else {
    try {
      // const user = await Auth.currentUserInfo()
      const attributes = await fetchUserAttributes()
      if (attributes?.name && attributes?.email) {
        const { name, email } = attributes
        userDetails = { name, email }
      }
      return userDetails
    } catch (err) {
      // TODO: This functions is already setup like using global variables and used everywhere when project was initiated need to find better way to handle this
    }
  }
}

const AuthService = {
  getUserDetails,
  setUserDetails,
  clearUserDetails
}

export default AuthService
